import { Component, Input, OnInit } from '@angular/core';
import {
  GetManufacturerRequest, ICompany, SituViewWebApiClient, UploadManufacturerLogoRequest
} from 'situview-webapi-client';
import { AuthService, BreadcrumbService } from 'src/app/services';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.less']
})

export class CompanyComponent implements OnInit {
  @Input() manufacturerId: string = '';
  @Input() companyId: string = '';

  id: string = '';
  company: string = '';
  manufacturer: ICompany | null = null;
  productImpressionLogo: string = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private situViewClient: SituViewWebApiClient,
    private authService: AuthService,
    private snackBar: MatSnackBar,
    private breadcrumbService: BreadcrumbService) { }

  ngOnInit(): void {
    this.id = this.route.snapshot.params['companyId'];

    const defaultCompanyCode = this.authService.getDefaultCompanyCode() ?? '';
    if (!this.company) {
      this.company = defaultCompanyCode;
    }

    this.loadManufacturer();
  }

  onAssetLoad(assetBase64: string) {
    if (assetBase64) {
      this.productImpressionLogo = assetBase64;
    }
  }

  onSaveClick() {
    let uploadManufacturerLogoRequest = new UploadManufacturerLogoRequest();
    uploadManufacturerLogoRequest.manufacturerId = this.id;
    uploadManufacturerLogoRequest.manufacturerLogo = this.productImpressionLogo ? this.productImpressionLogo.split(',')[1] : undefined;
    this.situViewClient.uploadManufacturerLogo(uploadManufacturerLogoRequest)
      .then(x => {
        if (x.success) {
          (this.manufacturer as ICompany).logoUrl = x.manufacturerLogoUrl;
          this.snackBar.open(`Logo successfully updated!`, 'OK', { duration: 2000 });
        } else {
          this.snackBar.open(`Could not fetch the company. Refresh Page.`, 'OK', { duration: 2000 });
        }
      })
      .catch(x => {
        this.snackBar.open(`Failed to upload product impression logo`, 'OK', { duration: 2000 });
      });
  }

  private loadManufacturer(): void {
    let getManufacturerRequest = new GetManufacturerRequest();
    getManufacturerRequest.manufacturerId = this.id;
    this.situViewClient.getManufacturer(getManufacturerRequest)
      .then(x => {
        if (x.success) {
          this.manufacturer = x.manufacturer ?? null;
          this.breadcrumbService.setParam('companyName', this.manufacturer?.name);
        } else {
          this.snackBar.open(`Could not fetch the company. Refresh Page.`, 'OK', { duration: 2000 });
        }
      });
  }
}
